import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { roleService } from 'src/app/services/role.service';
import { LanguageService } from './services/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    // -i18n- LanguageService injecté ici : la langue enregistrée est appliquée avant le premier affichage
    constructor(private router: Router, private authService: AuthService, private roleService: roleService,
                private language: LanguageService) {}

 ngOnInit(): void {
  //ce code pour refresh token en cas de refresh page
 const expiresAtStr = localStorage.getItem('expires_at');
if (expiresAtStr) {

  this.authService.startRefreshTokenTimer(expiresAtStr.toString());

}
  

}
  

}
